"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimDispenserControlSafetyMicroOutValidation = void 0;
class SimDispenserControlSafetyMicroOutValidation {
    static isValid(entity) {
        // If entity.v_hvdc exists, validate that it has the correct type.
        if (entity.v_hvdc != undefined) {
            if (typeof entity.v_hvdc !== "number")
                return false;
        }
        // If entity.i_hvdc exists, validate that it has the correct type.
        if (entity.i_hvdc != undefined) {
            if (typeof entity.i_hvdc !== "number")
                return false;
        }
        // If entity.v_cp_pos_mv exists, validate that it has the correct type.
        if (entity.v_cp_pos_mv != undefined) {
            if (typeof entity.v_cp_pos_mv !== "number")
                return false;
        }
        // If entity.v_cp_neg_mv exists, validate that it has the correct type.
        if (entity.v_cp_neg_mv != undefined) {
            if (typeof entity.v_cp_neg_mv !== "number")
                return false;
        }
        // If entity.v_pp_mv exists, validate that it has the correct type.
        if (entity.v_pp_mv != undefined) {
            if (typeof entity.v_pp_mv !== "number")
                return false;
        }
        // If entity.t_contact_p_c exists, validate that it has the correct type.
        if (entity.t_contact_p_c != undefined) {
            if (typeof entity.t_contact_p_c !== "number")
                return false;
        }
        // If entity.t_contact_n_c exists, validate that it has the correct type.
        if (entity.t_contact_n_c != undefined) {
            if (typeof entity.t_contact_n_c !== "number")
                return false;
        }
        // If entity.fault_hvdc_ovp exists, validate that it has the correct type.
        if (entity.fault_hvdc_ovp != undefined) {
            if (typeof entity.fault_hvdc_ovp !== "boolean")
                return false;
        }
        // If entity.fault_hvdc_ocp exists, validate that it has the correct type.
        if (entity.fault_hvdc_ocp != undefined) {
            if (typeof entity.fault_hvdc_ocp !== "boolean")
                return false;
        }
        // If entity.fault_hvdc_uvp exists, validate that it has the correct type.
        if (entity.fault_hvdc_uvp != undefined) {
            if (typeof entity.fault_hvdc_uvp !== "boolean")
                return false;
        }
        // If entity.fault_imd_low_res exists, validate that it has the correct type.
        if (entity.fault_imd_low_res != undefined) {
            if (typeof entity.fault_imd_low_res !== "boolean")
                return false;
        }
        // If entity.is_connected exists, validate that it has the correct type.
        if (entity.is_connected != undefined) {
            if (typeof entity.is_connected !== "boolean")
                return false;
        }
        // If entity.contactor_fsm_state exists, validate that it has the correct type.
        if (entity.contactor_fsm_state != undefined) {
            if (typeof entity.contactor_fsm_state !== "number")
                return false;
        }
        // If entity.imd_state exists, validate that it has the correct type.
        if (entity.imd_state != undefined) {
            if (typeof entity.imd_state !== "number")
                return false;
        }
        // If entity.v_ev_hvdc_0p1v exists, validate that it has the correct type.
        if (entity.v_ev_hvdc_0p1v != undefined) {
            if (typeof entity.v_ev_hvdc_0p1v !== "number")
                return false;
        }
        return true;
    }
}
exports.SimDispenserControlSafetyMicroOutValidation = SimDispenserControlSafetyMicroOutValidation;
